import { FullScreenBgSection, useFullScreenSectionDims } from '../../../elements/sections'
import { useLargestHeight } from '../../../hooks'
import { FadingCarousel } from '../../carousels/FadingCarousel/FadingCarousel'
import { ComponentError, ComponentPlaceholder } from '../../status'
import statusMsgs from '../../status/messages'
import { HorizontalScrollStop } from '../FullScreenSection/FullScreenBgSection'

export const CarouselSection = ({
  loading,
  error,
  items,
  renderItem,
  fadeDelay,
  autoScroll,
  scrollPositionSlug,
  showActivityIndicator,
  ...props
}) => {
  const { measuredHeight, onLayout } = useLargestHeight()
  const { width, height } = useFullScreenSectionDims({ measuredHeight, ...props })

  if (loading)
    return (
      <ComponentPlaceholder
        width={width}
        height={height}
        activityIndicator={showActivityIndicator}
      />
    )
  if (error)
    return <ComponentError width={width} height={height} {...statusMsgs.contentLoadError} />

  return (
    <HorizontalScrollStop>
      <FadingCarousel
        items={items}
        style={{ width, height }}
        fadeDelay={fadeDelay}
        autoScroll={autoScroll}
        scrollPositionSlug={scrollPositionSlug}
      >
        {(item, index) => (
          <FullScreenBgSection
            {...props}
            bgImgIdLandscape={item.landscapeBg}
            bgImgIdPortrait={item.portraitBg}
            onLayout={onLayout}
          >
            {renderItem({ item, index, width, height })}
          </FullScreenBgSection>
        )}
      </FadingCarousel>
    </HorizontalScrollStop>
  )
}
